export const RegisteredForWaitListPropertyName = 'registered_for_wait_list'
export const RegisteredForOutOfStateWaitListPropertyName = 'registered_for_out_of_state_wait_list'
